import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const KeyIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM13 11l-8 8M5 19l2 2M7 17l2 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default KeyIcon;